document.addEventListener('DOMContentLoaded', function () {
  var btn = document.getElementById('back-to-top');
  if (!btn) return;

  window.addEventListener('scroll', function () {
    if (window.scrollY > 300) {
      btn.style.display = 'flex';
      setTimeout(function () {
        btn.style.opacity = '1';
        btn.style.transform = 'translateY(0)';
      }, 10);
    } else {
      btn.style.opacity = '0';
      btn.style.transform = 'translateY(8px)';
      setTimeout(function () { btn.style.display = 'none'; }, 300);
    }
  }, { passive: true });

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});
